<template>

    <div class="row m-t-50 clearfix">
        <div class="col-xs-12">
            <div class="package-section clearfix" @mouseover="loadPopovers">
                <div class="container">
                    <div class="row">
                        <div class="col-md-4 col-md-offset-1 col-sm-12 col-xs-12 m-b-20 pull-right">
                            <div class="card cart-card">
                                <div class="card-body">
                                    <div class="panel-group accordion-list" id="accordion">
                                        <div class="panel panel-default">
                                            <div class="panel-heading" data-toggle="collapse" data-parent="#accordion"
                                                 href="#collapse1">
                                                <div class="vertical-align">
                                                    {{ trans('step2.my_reservation','My Reservation') }}
                                                    <span class="indicator fa fa-angle-up"></span>
                                                </div>
                                            </div>
                                            <div id="collapse1" class="panel-collapse collapse in">
                                                <div class="panel-body">
                                                    <div class="panel-container m-t-40" v-if="cart.packages.length > 0">
                                                        <div class="cart-package" v-for="cartPkg in cart.packages"
                                                             :key="'cart-'+cartPkg.id">
                                                            <div class="pkg-section addcart_content">
                                                                <p class="strong-text">
                                                                    <strong>{{trans('step2.packages.#'+cartPkg.id+'.name',cartPkg.name)}}</strong> <span
                                                                    @click="updateCart(cartPkg, 'remove')"
                                                                    class="pull-right">
                                                                <svg xmlns="http://www.w3.org/2000/svg" height="1em"
                                                                     viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path
                                                                    d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg>
                                                            </span>
                                                                </p>
                                                                <p>
                                                                    <strong class="strong-text">{{ trans('cart.qty','Qty') }} : </strong><span
                                                                    class="normal-text">&nbsp;&nbsp;{{
                                                                        cartPkg.qty
                                                                    }}</span>
                                                                    <strong class="m-l-15 strong-text">{{ trans('cart.price','Price') }} : </strong><span
                                                                    class="normal-text">&nbsp;&nbsp;{{
                                                                        currency_sign
                                                                    }}{{ thousandSeparator(cartPkg.total) }}</span>
                                                                    <strong class="m-l-15 cart-days strong-text">{{ trans('cart.days','days') }}
                                                                        : </strong><span class="normal-text">&nbsp;&nbsp;{{
                                                                        getRentalLength
                                                                    }}</span>
                                                                </p>
                                                            </div>
                                                            <div class="horizontal-divider m-t-20"></div>
                                                        </div>

                                                        <div class="row">
                                                            <div class="col-xs-12">
                                                                <p>
                                                                    <strong class="strong-text">{{trans('cart.subtotal','Subtotal')}} : </strong>
                                                                    <span class="normal-text">&nbsp;&nbsp;{{
                                                                            currency_sign
                                                                        }}{{ thousandSeparator(cartTotal) }}</span>
                                                                </p>
                                                                <p class="normal-text">{{trans('step2.tax_cal_checkout','Tax calculated at checkout')}}</p>
                                                            </div>
                                                        </div>
                                                        <div class="horizontal-divider m-t-20"></div>
                                                        <button type="button"
                                                                class="btn btn-primary continue-btn btn-block m-t-30"
                                                                @click="nextStep">{{ trans('step2.continue','Continue') }}
                                                        </button>
                                                    </div>
                                                    <div class="text-center" v-else>
                                                        <p class="empty-cart">{{trans('step2.empty_cart',"Empty Cart")}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card portal-section m-t-20" v-if="portal && portal.top_message">
                                <div class="card-body" v-html="portal.top_message">

                                </div>
                            </div>

                        </div>
                        <div class="col-md-7 col-sm-12 col-xs-12 clearfix">
                            <ul class="nav nav-tabs m-t-15">
                                <li :class="[tab==='ski' ? 'active' : '']"><a @click="tab='ski'" data-toggle="tab" href="#packages">SKIS</a>
                                </li>
                                <li :class="[tab==='snowboard' ? 'active' : '']"><a @click="tab='snowboard'" data-toggle="tab" href="#packages">SNOWBOARDS</a></li>
                            </ul>
                            <div class="tab-content m-t-15" style="max-height: unset;">
                                <div id="packages" class="tab-pane fade in active">
                                    <div class="package" v-for="pkg in tabPackages" :key="pkg.id">
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="thumbnail thumbnail-addon">
                                                    <img
                                                        :src="pkg && pkg.image ? pkg.image : base_url+'/cart-booking/static/assets/images/package.png'">
                                                </div>
                                            </div>
                                            <div class="col-md-8">
                                                <h3>{{ trans('step2.packages.#'+pkg.id+'.name',pkg.name) }}
                                                    <a class="info-icon pull-right m-t-5"
                                                       v-if="pkg.info"
                                                       href="Javascript:void(0)"
                                                       data-trigger="hover"
                                                       data-container=".package-section"
                                                       data-toggle="popover"
                                                       data-placement="top"
                                                       :data-content="trans('step2.packages.#'+pkg.id+'.info',pkg.info)"
                                                       data-original-title="" title="">
                                                        <svg height="16" viewBox="0 0 48 48" width="16"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M0 0h48v48h-48z" fill="none"/>
                                                            <path
                                                                d="M22 34h4v-12h-4v12zm2-30c-11.05 0-20 8.95-20 20s8.95 20 20 20 20-8.95 20-20-8.95-20-20-20zm0 36c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16zm-2-22h4v-4h-4v4z"/>
                                                        </svg>
                                                    </a>
                                                </h3>
                                                <p>{{ trans('step2.packages.#'+pkg.id+'.description',pkg.description) }}</p>
                                                <h3 class="price-text">
                                                    <span :class="[coupon ? 'deleted-price' : '']">{{
                                                            currency_sign
                                                        }}{{ thousandSeparator(pkg.price) }}/{{ trans('cart.day','day') }}</span>

                                                    <span
                                                        v-if="coupon">{{ thousandSeparator(getDiscountedPrice(pkg.price, coupon.discount)) }}/{{ trans('cart.day','day') }}</span>
                                                    <small v-if="pkg.max_price">
                                                        ({{trans('cart.max_price','Max Price')}} {{
                                                            currency_sign
                                                        }}{{ thousandSeparator(pkg.max_price) }})
                                                    </small>
                                                </h3>
                                                <p><strong>{{trans('general.renters','Renters')}}</strong></p>
                                                <div>
                                                    <div class="quantity-box">
                                                        <button class="minus-btn" @click="decrement(pkg)"><span
                                                            class="fa fa-minus"></span></button>
                                                        <div class="quantity">{{ pkg.qty }}</div>
                                                        <button class="plus-btn" @click="increment(pkg)"><span
                                                            class="fa fa-plus"></span></button>
                                                    </div>
                                                    <button class="btn btn-primary add-to-cart-btn"
                                                            @click="updateCart(pkg)">{{trans('step2.add_to_cart','Add to Cart')}}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="horizontal-divider"></div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="text-center">
                <div class="mobail-menu-fix">
                    <div class="row">
                        <div class="col-md-12">
                            <a href="Javascript:void(0)">
                                <!--                        <img :src="base_url+'/cart-booking/images/cart.svg'" alt="">-->
                                <span class="fa fa-shopping-cart fa-2x text-primary"><sup class="badge badge-primary"
                                                                                          v-if="renters.length > 0">{{
                                        renters.length
                                    }}</sup></span>
                            </a>
                            <p>{{trans('general.subtotal','Subtotal')}}: {{ currency_sign }}{{ thousandSeparator(cartTotal) }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import {mapGetters, mapState, mapActions} from "vuex";
import Cart from "../components/steps/Cart";

export default {
    name: 'NewPackageSection',
    props: ['fromWp'],
    components: {Cart},
    data() {
        return {
            tab: 'ski'
        }
    },
    beforeMount() {
        if (!this.step1_completed) {
            if (this.fromWp) {
                location.href = window.location.origin + window.location.search;
                // this.updateStep({'step': 1});
            } else {
                this.$router.push(this.$store.getters.getStep1Route);
            }
        }
    },
    mounted() {
        $('.accordion-list .panel-heading').click(function () {
            $('.indicator').not($(this).children()).removeClass('fa-angle-up').addClass('fa-angle-down');
            $(this).find('.indicator').toggleClass('fa-angle-down fa-angle-up');
        });
        document.body.classList.remove('bg-body-light')
        document.body.classList.add('bg-gray')

        this.$store.state.coupon = null;
        this.$store.dispatch('applyGlobalCoupon');
        this.getData();

        //remove text-justify
        $('span, p, div, h1, h2, h3, h4, h5, h6', $('.portal-section')).each(function () {
            $(this).css('text-align', 'left');
        });
        console.log({'step1prams': this.$store.state.form.step1_params})
    },
    computed: {
        step1_completed() {
            return (this.form.resort_id && this.form.delivery_date && this.form.delivery_time && this.form.return_date)
        },
        selected_skis: {
            get() {
                return this.$store.state.selected_skis;
            },
            set(value) {
                this.$store.commit('SET_SELECTED_SKIS', value);
            }
        },
        selected_snowboards: {
            get() {
                return this.$store.state.selected_snowboard;
            },
            set(value) {
                this.$store.commit('SET_SELECTED_SNOWBOARDS', value);
            }
        },
        tabPackages() {
            let tab = this.tab;
            return this.packages.filter(pkg => pkg.equip_type === tab && pkg.for_booking_cart == 1);
        },

        cartTotal() {
            let total = 0;
            this.cart.packages.forEach(item => {
                total += parseFloat(item.total);
            })
            return total;
        },
        ...mapGetters(['getRentalLength', 'getLimitationAge']),
        ...mapState(['portal', 'package_limitations', 'coupon', 'auth_user', 'form', 'currency_sign', 'packages', 'cart', 'selected_skis', 'selected_snowboards', 'renters', 'base_url']),
    },
    methods: {
        trans(key, defaultValue,msg=null) {
            let translation = '';
            if(msg){
                translation = this.$t(key,{message:msg});
            }else{
                translation = this.$t(key);
            }
            return translation !== key ? translation : defaultValue;
        },
        loadPopovers() {
            $('[data-toggle="popover"]').popover()
        },
        getData() {
            this.$store.dispatch('fetchPackages');
        },
        getSelectedRenterOptionLabel(option) {
            var str = option.full_name;
            var matches = str ? str.match(/\b(\w)/g) : []; // ['J','S','O','N']
            var acronym = matches.join(''); // JSON
            option.short_label = acronym;
            return option.short_label;
        },

        updateCart(pkg, flag = null) {
            if (flag === 'remove') {
                pkg.qty = 0; //delete from cart
                this.$forceUpdate();
            }
            this.$store.dispatch('updateCartWithRenters', pkg);
            this.$store.dispatch('setSummaryPage');
            this.$forceUpdate();
        },
        addOrRemoveItemInCart(selected_pacakge, val) {
            let _this = this;

            //on select
            if (val !== undefined) {
                selected_pacakge.qty++;
                _this.updateCart(selected_pacakge)
            } else {
                //on deselect
                selected_pacakge.qty--;
                _this.updateCart(selected_pacakge)
            }
        },
        increment(pkg) {
            pkg.qty = pkg.qty + 1;
            this.$forceUpdate();
        },
        decrement(pkg) {
            if (pkg.qty > 0) {
                pkg.qty = pkg.qty - 1;
                this.$forceUpdate();
            }
        },


        isJrPackage(pkg) {
            return (pkg.has_limitations === 1 || pkg.is_krf === 1);
        },

        isTeenPackage(pkg) {
            return (pkg.is_teen === 1);
        },

        readMore(pkg) {
            pkg.read_more = 1;
            this.$forceUpdate();
        },
        readLess(pkg) {
            pkg.read_more = 0;
            this.$forceUpdate();
        },

        nextStep() {
            let _this = this;
            this.setLoading({'loading': true})

            if (this.fromWp) {
                if (this.base_url === window.location.origin) {
                    this.putDataInStorage();
                    if (this.auth_user) {
                        location.href = '/reservations/step3'
                    } else {
                        location.href = '/reservations/login'
                    }
                } else {
                    //from wordpress
                    this.putDataInStorage(true).then(res => {
                        localStorage.removeItem('store_state');
                        _this.$store.dispatch('setLoading',{'loading': false});
                        location.href = _this.base_url+"/reservations/login?ucid=" + encodeURIComponent(res.data.data.id)

                    }).catch(error => {
                        _this.$store.dispatch('setLoading',{'loading': false});
                        let er = error.response ? error.response.data.message : error;
                        console.log(er);
                        swal({
                            title: "Error!",
                            text: "Something went wrong, please try again!",
                            // type: "error",
                            imageUrl: "/images/warning-alert.png",  // Replace with the path to your custom image
                            showConfirmButton: true
                        });
                    })
                }


            } else {
                NProgress.start();
                this.putDataInStorage();

                this.setLoading({'loading': false});
                if (this.auth_user) {
                    this.$router.push({name: 'Step3'});
                } else {
                    this.$router.push({name: 'Login'});
                }
            }

        },

        onlyLastWord(words) {
            var n = words.split(" ");
            return n[n.length - 1];
        },
        exceptLastWord(str) {
            if (str) {
                var lastIndex = str.lastIndexOf(" ");
                str = str.substring(0, lastIndex);
            }
            return str;
        },
        ...mapActions(['setLoading', 'putDataInStorage', 'updateStep'])
    }
}
</script>
